import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { PontoService } from './ponto.service';
import { CommonModule } from '@angular/common';
import { Base64 } from 'js-base64';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements OnInit {
  protected title = 'redirect-frontend';
  isLoading = false;
  decodedData: any;
  state: string | undefined;
  code: string | undefined;
  error: string | undefined;

  constructor(private pontoService: PontoService, private route: ActivatedRoute, private router: Router,) {}

  ngOnInit(): void {
    // Read URL parameters
    this.route.queryParams.subscribe((params) => {
       this.code = params['code'];
       this.state = params['state'];
       this.error = params['error'];

      console.log('Code:', this.code);
      console.log('State:', this.state);
      console.log('Error:', this.error);
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.handleNavigationEnd(event);
      }
    });
  }

  createInitialToken(vehicleId: string, payload: {state: string, code: string}): void {
    this.isLoading = true;
    this.pontoService.createInitialToken(vehicleId, payload).subscribe({
      next: () => {
        this.isLoading = false;
        console.log('Token created successfully');
        this.redirectToGpPortal(this.decodedData);
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error creating token:', err);
        this.redirectToGpPortal(this.decodedData);
      },
    });
  }

  decodeRandomString(encodedString: string): { randomString: string; gpId: string; vehicleId: string } {
    const decodedData = Base64.decode(encodedString);
    const [randomString, gpId, vehicleId] = decodedData.split(':');
    return { randomString, gpId, vehicleId };
  }

  redirectToGpPortal(decodedData: { randomString: string; gpId: string; vehicleId: string }): void {
    const gpPortalDomain = environment.gpPortalAppUrl;
    window.location.href = `${gpPortalDomain}gp/${decodedData.gpId}/vehicle/${decodedData.vehicleId}/settings/bank-accounts`;
  }

  handleNavigationEnd(_event: NavigationEnd): void {
    if (this.state || this.code || this.error) {
      this.decodedData = this.decodeRandomString(this.state!);
      console.log('Decoded Data:', this.decodedData);
      if (!this.error) {
        this.createInitialToken(this.decodedData.vehicleId, { state: this.state!, code: this.code! });
      } else {
        this.redirectToGpPortal(this.decodedData);
      }
    }
  }
}
